import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { PersonalizationProvider } from './contexts/PersonalizationContext';
import { BookingProvider } from './contexts/BookingContext';
import { BreadcrumbProvider } from './components/BreadcrumbProvider.jsx';
import { HelmetProvider } from 'react-helmet-async';
import BookingModal from './components/BookingModal';
import { useBooking } from './contexts/BookingContext';

const AppContent = () => {
  const { isBookingOpen, closeBooking } = useBooking();

  return (
    <>
      <Routes />
      <BookingModal isOpen={isBookingOpen} onClose={closeBooking} />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <PersonalizationProvider>
          <AuthProvider>
            <BookingProvider>
              <BreadcrumbProvider>
                <AppContent />
              </BreadcrumbProvider>
            </BookingProvider>
          </AuthProvider>
        </PersonalizationProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;